import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CallLookups = ({ callId }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/business/calls/${callId}/lookups`).then((r) => setItems(r.data.lookups)).catch(() => setItems([]));
  }, [callId]);

  if (!items.length) return null;
  return (
    <div data-testid="call-lookups">
      <p className="text-muted-foreground text-sm mb-2 flex items-center gap-2"><Search className="w-4 h-4" /> What your Pro checked</p>
      <div className="space-y-2">
        {items.map((l) => (
          <div key={l.id} className="bg-muted rounded p-3 text-sm" data-testid={`call-lookup-${l.id}`}>
            <p className="text-foreground">Looked up <span className="font-semibold">"{l.query}"</span> in {l.connection_name}
              <span className="text-xs text-muted-foreground ml-2">{new Date(l.created_at).toLocaleTimeString()}</span></p>
            <p className={`text-xs mt-1 break-all line-clamp-3 ${l.ok ? 'text-muted-foreground' : 'text-red-500'}`}>{l.ok ? `Found: ${l.result}` : l.result}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-2">What your Pro told the caller is in the transcript below.</p>
    </div>
  );
};
